export default __webpack_public_path__ + "static/media/econnect.baeff7d5.svg";